import React, { useEffect, useState } from "react";
import LeftSideBar from "../../../components/LeftSideBar/LeftSideBar";
import Header from "../../../components/Header/Header";
import AdministratorHeader from "../../../components/Header/AdministratorHeader";
import {
  Grid,
  Button,
  Box,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  InputBase,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Checkbox,
  OutlinedInput,
  InputAdornment,
  Tooltip,
} from "@mui/material";
import DateRangePicker from "../../../components/DateRangePicker";
import * as acts from "../../../redux/administrator/actions";
import { useDispatch, useSelector } from "react-redux";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import moment from "moment";
import SearchIcon from "@mui/icons-material/Search";
import TablePagination from "@mui/material/TablePagination";
import "./outPutFormat.scss";
import DashboardTableSkaleton from "../../../components/Skeletons/DashboardTableSkaleton";
import DPFiterModal from "../../../components/Modal/DataPointFIlter/DPFilterModal";
import CustomizedSnackbars from "../../../components/Snackbars/CustomizedSnackbars";
import FunctionsIcon from "@mui/icons-material/Functions";
export default function DataPointDetails() {
  const Dispatch = useDispatch();
  const dataPoints = useSelector((state) => state?.admin?.dataPointDetail);
  const [dpPoint, setDpPoint] = useState(dataPoints?.data);
  const [file, setFile] = useState("");
  const [pageCount, setPageCount] = useState(dataPoints?.total_count || 0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const apiStatus = useSelector((state) => state?.admin?.apiStatus);
  const [page, setPage] = useState(0);
  const [sDate, setSDate] = useState("");
  const [eDate, setEDate] = useState("");
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [projectId, setProjectId] = useState("");
  const [projectName, setProjectName] = useState("");
  const [filterOne, setFilterOne] = useState([]);
  const [filterTwo, setFilterTwo] = useState([]);
  const [snackBarState, setSnackbarState] = useState(false);
  const [severity, setSeverity] = useState("");
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [formulaName, setFormulaName] = useState("");
  const [searchParams, setSearchParams] = useState("");
  const [editFormula, setEditFormula] = useState(false);
  const [error, setError] = useState("");
  const [formulaId, setFormulaId] = useState("");
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet:charset=UTF-8";
  const fileExtension = ".xlsx";
  const dPProjectNames = useSelector((state) => state?.admin?.dPCustomWord);
  const dPFilterOne = useSelector((state) => state?.admin?.dpFilterOne);
  const dpFormulaList = useSelector((state) => state?.admin?.dpFormulaList);
  const dpCalculationLink = useSelector(
    (state) => state?.admin?.dpCalculationLink,
  );
  console.log(dpFormulaList, "dpformula list");
  useEffect(() => {
    const data = {
      page: page + 1,
      page_size: rowsPerPage,
      formattedStartDate: sDate,
      formattedEndDate: eDate,
      file,
    };
    Dispatch(acts.getDpDetails(data));
    Dispatch(acts.getDPProjectsNames());
    Dispatch(acts.getFormulasList());
  }, [Dispatch, rowsPerPage]);

  useEffect(() => {
    if (dataPoints?.data?.length > 0) {
      setDpPoint(dataPoints?.data);
    } else {
      setDpPoint([]);
    }
    setRowsPerPage(rowsPerPage);
    setPageCount(dataPoints?.total_count);
  }, [dataPoints?.data, pageCount, dpPoint]);

  const exportToExcel = async () => {
    const ws = XLSX.utils.json_to_sheet(dataPoints?.data);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, "DPDetails" + fileExtension);
  };

  const filterByDate = (startDate, endDate, status) => {
    const formattedStartDate =
      startDate !== "" ? moment(startDate).format("YYYY-MM-DD") : "";
    const formattedEndDate =
      endDate !== "" ? moment(endDate).format("YYYY-MM-DD") : "";
    setSDate(formattedStartDate);
    setEDate(formattedEndDate);
    setPage(0);
    setRowsPerPage(100);
    const data = {
      page: page + 1,
      page_size: rowsPerPage,
      formattedStartDate,
      formattedEndDate,
      file,
      searchParams,
    };
    Dispatch(acts.getDpDetails(data));

    setPageCount(dataPoints?.total_count);
  };

  const handleChange = (event) => {
    setPage(0);
    setFile(event.target.value);
  };

  const onSearch = (word) => {
    let result;
    if (word) {
      result = dataPoints?.data?.filter(function (el) {
        return (
          el?.file_name.toString().toLowerCase().indexOf(word.toLowerCase()) !==
          -1
        );
      });
    } else {
      result = dataPoints?.data;
    }
    setDpPoint([...result]);
  };

  useEffect(() => {
    if (apiStatus !== undefined) {
      if (apiStatus.apiError !== null && apiStatus.next === false) {
        // if (apiStatus.apiError === true) {
        //   setSnackbarState(true);
        //   setSnackbarMessage(apiStatus.message);
        //   setSeverity("error");
        // }
      } else if (apiStatus.apiSuccess === true && apiStatus.next === true) {
        if (apiStatus?.downloadLink === true) {
          const downloadLink = dpCalculationLink?.data?.file_path; // Retrieve the file path from the state
          if (downloadLink) {
            // Create a temporary anchor element
            const anchor = document.createElement("a");
            anchor.href = downloadLink;

            // Set the download attribute to force download
            anchor.download = "";

            // Programmatically trigger a click event on the anchor element
            anchor.click();

            //Remove the anchor element
            // document.body.removeChild(anchor);
            setSnackbarState(true);
            setSnackbarMessage("File Downloaded Successfully");
            setSeverity("success");
            Dispatch(acts.clearDPCalculation());
            setSelectedCheckboxes([]);
            setFilterOne([]);
            setFilterTwo([]);
            setProjectName("");
            Dispatch(acts.getDPProjectsNames());
            Dispatch(acts.getFormulasList());
          }
        }
        if (apiStatus?.saveFormula === true) {
          setSnackbarState(true);
          setSnackbarMessage("Formula Saved Successfully");
          setSeverity("success");
          Dispatch(acts.clearDPCalculation());
          setSelectedCheckboxes([]);
          setFilterOne([]);
          setFilterTwo([]);
          setProjectName("");
          Dispatch(acts.getDPProjectsNames());
          Dispatch(acts.getFormulasList());
        }
        if (apiStatus?.updateSuccess === true) {
          setSnackbarState(true);
          setSnackbarMessage("Formula Updated Successfully");
          setSeverity("success");
          Dispatch(acts.clearDPCalculation());
          setSelectedCheckboxes([]);
          setFilterOne([]);
          setFilterTwo([]);
          setProjectName("");
          Dispatch(acts.getDPProjectsNames());
          Dispatch(acts.getFormulasList());
        }
        if (apiStatus?.deleteSuccess === true) {
          setSnackbarState(true);
          setSnackbarMessage("Formula Deleted Successfully");
          setSeverity("success");
          Dispatch(acts.clearDPCalculation());
          setSelectedCheckboxes([]);
          setFilterOne([]);
          setFilterTwo([]);
          setProjectName("");

          Dispatch(acts.getDPProjectsNames());
          Dispatch(acts.getFormulasList());
        }
        // if (apiStatus?.message)
      }
    }
  }, [apiStatus]);

  const handlePageChange = (event, value) => {
    setPage(value);
    const data = {
      page: value + 1,
      page_size: rowsPerPage,
      formattedStartDate: sDate,
      formattedEndDate: eDate,
      file,
    };
    Dispatch(acts.getOutPutList(data));
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    setPage(0);
  };

  const handleChangeProjectName = (event) => {
    const projectName = event.target.value;
    const selectedProject = dPProjectNames?.data.find(
      (project) => project.project_name === projectName,
    );

    if (selectedProject) {
      const projectId = selectedProject.project_id;

      setProjectId(projectId);
      setProjectName(projectName);
      Dispatch(acts.getDPFilterOne(projectId));
    }
  };

  const handleFilterOne = (event) => {
    setFilterOne(event.target.value);
  };

  const handleFilterTwo = (event) => {
    setFilterTwo(event.target.value);
  };
  const handleSubmit = () => {
    setOpenModal(true);
  };

  const handleClose = () => {
    setOpenModal(false);
  };

  const handleModal = () => {
    setOpenModal(true);
  };

  const handleCheckboxChange = (event, id, fileName) => {
    const isChecked = event.target.checked;
    let newSelected = [];

    if (isChecked) {
      // Add the id to selectedCheckboxes
      newSelected = [...selectedCheckboxes, { id, fileName }];
    } else {
      // Remove the id from selectedCheckboxes
      newSelected = selectedCheckboxes.filter((checkbox) => {
        return !(checkbox.id === id && checkbox.fileName === fileName);
      });
    }

    setSelectedCheckboxes(newSelected);
  };

  const handleSelectAllClick = (event) => {
    const isChecked = event.target.checked;

    if (isChecked) {
      const newSelected = dpPoint.map((list) => {
        return { id: list.id, fileName: list.file_name };
      });
      setSelectedCheckboxes(newSelected);
      setSelectAllChecked(true);
    } else {
      setSelectedCheckboxes([]);
      setSelectAllChecked(false);
    }
  };

  const handleFormulaName = (event) => {
    const value = event.target.value;
    // Regular expression to check if the value contains only letters, digits, underscores, or hyphens
    const regex = /^[a-zA-Z0-9_-]*$/;
    if (regex.test(value)) {
      setFormulaName(value);
      setError("");
    } else {
      setError("Special characters are not allowed except '_' and '-'");
    }
  };

  const handleSaveFormula = () => {
    console.log("inside handle save formula");
    setEditFormula(false);
    const data = {
      project_id: projectId,
      formula_name: formulaName,
      unique_column_headers: filterOne,
      non_unique_column_headers: filterTwo,
    };

    Dispatch(acts.saveFormula(data));
  };

  const handleUpdateFormula = (row) => {
    console.log("inside handle save formula");
    setEditFormula(false);
    const data = {
      project_id: formulaId,
      formula_name: formulaName,
      unique_column_headers: filterOne,
      non_unique_column_headers: filterTwo,
    };

    Dispatch(acts.updateFormula(data));
  };

  const handlefilterDelete = (row) => {
    console.log("inside handle save formula");
    setEditFormula(false);
    const data = {
      project_id: row.id,
      // formula_name: formulaName,
      // unique_column_headers: filterOne,
      // non_unique_column_headers: filterTwo,
    };

    Dispatch(acts.deleteFormula(data));
  };

  const handleFilterEdit = (row) => {
    setFormulaId(row.id);
    console.log(row, "rowwwvaleuesevevrebvrbv");
    setEditFormula(true);
    setFilterTwo(row?.non_unique_column_headers);
    setFilterOne(row?.unique_column_headers);
    setFormulaName(row?.name);

    const selectedProject = dPProjectNames?.data.find(
      (project) => project.project_id === row.project_id,
    );
    setProjectName(selectedProject.project_name);
    Dispatch(acts.getDPFilterOne(row.project_id));
  };

  const handleDPCalculation = () => {
    const data = {
      file_ids_list: selectedCheckboxes.map((item) => item.id),
      // project_id: projectId,
      formula_name: formulaName,
      unique_column_headers: filterOne,
      non_unique_column_headers: filterTwo,
    };
    Dispatch(acts.dpCalculation(data));
  };

  return (
    <>
      <Header page="new-project" />
      <Box>
        <Grid className="sidebar-main" container>
          <Grid item className="sidebar-container">
            <LeftSideBar page="sidebar" />
          </Grid>
          <Grid item className="visualization-conatiner">
            <AdministratorHeader text="Data Point Details" />
            <Grid
              container
              style={{ margin: "0px 21px" }}
              className="dp-main-container"
            >
              <Grid container spacing={2}>
                <Grid
                  item
                  xs={2}
                  className="select-grid"
                  style={{ width: "239px", marginRight: "16px" }}
                >
                  <FormControl fullWidth size="small">
                    <InputLabel
                      className="multiple-controlsLabel"
                      labelId="demo-multiple-name-label"
                      id="demo-multiple-name-label"
                    >
                      Project Name
                    </InputLabel>
                    <Select
                      // size="small"
                      value={projectName}
                      onChange={handleChangeProjectName}
                      inputProps={{ "aria-label": "Without label" }}
                    >
                      {dPProjectNames?.data.map((index) => {
                        return (
                          <MenuItem
                            key={index.project_id}
                            value={index.project_name}
                          >
                            {index.project_name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={2} className="select-grid">
                  <FormControl fullWidth size="small">
                    <InputLabel
                      className="multiple-controlsLabel"
                      id="demo-multiple-name-label"
                    >
                      Unique Column Header
                    </InputLabel>
                    <Select
                      // size="small"
                      multiple
                      value={filterOne}
                      onChange={handleFilterOne}
                      disabled={projectName.length === 0}
                      inputProps={{ "aria-label": "Without label" }}
                      renderValue={(selected) => selected.join(", ")}
                    >
                      {dPFilterOne?.data.map((index) => (
                        <MenuItem key={index} value={index}>
                          <Checkbox
                            checked={filterOne.indexOf(index) > -1}
                            color="primary"
                          />
                          {index}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={2} className="select-grid">
                  <FormControl fullWidth size="small">
                    <InputLabel
                      className="multiple-controlsLabel"
                      id="demo-multiple-name-label"
                    >
                      Non unique headers
                    </InputLabel>
                    <Select
                      // size="small"
                      multiple
                      value={filterTwo}
                      onChange={handleFilterTwo}
                      disabled={projectName.length === 0}
                      inputProps={{ "aria-label": "Without label" }}
                      renderValue={(selected) => selected.join(", ")}
                    >
                      {dPFilterOne?.data.map((index) => (
                        <MenuItem key={index} value={index}>
                          <Checkbox
                            checked={filterTwo.indexOf(index) > -1}
                            color="primary"
                          />
                          {index}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid
                  style={{ display: "flex", flexDirection: "row" }}
                  item
                  xs={2}
                >
                  {/* {selectedCheckboxes.length > 0 && ( */}
                  <Button
                    size="small"
                    style={{ height: "42px" }}
                    variant="outlined"
                    className="btn-search"
                    onClick={handleDPCalculation}
                    disabled={filterOne.length === 0 && filterTwo.length === 0}
                  >
                    Proceed
                  </Button>
                  {/* )} */}

                  {/* <Button
                    onClick={handleModal}
                    aria-label="saved filters"
                    // className="download-btn"
                  > */}
                  <IconButton className="download-btn" onClick={handleModal}>
                    <Tooltip title="Saved Formulas">
                      <FunctionsIcon
                        size="small"
                        color="primary"
                        sx={{
                          height: "30px !important",
                          width: "30px !important",
                          // alignItems: "baseline",
                          marginBottom: "8px !important",
                          Left: "20px",
                        }}
                      />
                    </Tooltip>
                  </IconButton>
                </Grid>
                <Grid item xs={3}>
                  <FormControl size="small">
                    <OutlinedInput
                      size="small"
                      className="input-wrap"
                      //style={{width:"231px"}}
                      fullWidth={true}
                      placeholder="Formula Name"
                      required
                      onChange={handleFormulaName}
                      name="Formula Name"
                      value={formulaName}
                      error={error !== ""}
                      helperText={error}
                      inputProps={{
                        pattern: "[A-Za-z0-9_-]*",
                        style: { color: error ? "red" : "inherit" }, // Change text color to red if there's an error
                      }}
                      disabled={
                        filterOne.length === 0 && filterTwo.length === 0
                      }
                      endAdornment={
                        <InputAdornment position="end">
                          {editFormula ? (
                            <IconButton
                              onClick={handleUpdateFormula}
                              disabled={
                                (filterOne.length === 0 &&
                                  filterTwo.length === 0) ||
                                formulaName.trim() === "" ||
                                error !== ""
                              }
                              // onMouseDown={this.handleMouseDownPassword}
                            >
                              <Button>Update</Button>
                            </IconButton>
                          ) : (
                            <IconButton
                              onClick={handleSaveFormula}
                              disabled={
                                (filterOne.length === 0 &&
                                  filterTwo.length === 0) ||
                                formulaName.trim() === ""
                              }
                              // onMouseDown={this.handleMouseDownPassword}
                            >
                              <Button>Save</Button>
                            </IconButton>
                          )}
                        </InputAdornment>
                      }
                    ></OutlinedInput>
                  </FormControl>
                </Grid>
              </Grid>
              <Grid
                container
                style={{ margin: "1px" }}
                spacing={2}
                //  className="DataPointDetails-container"
                // columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              >
                <Grid
                  item
                  xs={2}
                  className="search"
                  size="small"
                  sx={{ marginTop: "16px !important" }}
                >
                  <InputBase
                    size="small"
                    id="searchInput"
                    className="input-style"
                    placeholder={"Project Name"}
                    inputProps={{ "aria-label": "search" }}
                    onChange={(event) => setSearchParams(event.target.value)}
                  />
                </Grid>
                <Grid item xs={2} className="select-grid">
                  <FormControl
                    fullWidth
                    className="datapoint-multiple-controls"
                    size="small"
                  >
                    <InputLabel
                      // className="multiple-controlsLabel"
                      style={{ width: "150px" }}
                      labelId="demo-multiple-name-label"
                      id="demo-multiple-name-label"
                    >
                      File Extension
                    </InputLabel>
                    <Select
                      size="small"
                      value={file}
                      onChange={handleChange}
                      inputProps={{ "aria-label": "Without label" }}
                    >
                      <MenuItem value="xlsx">xlsx</MenuItem>
                      <MenuItem value="csv">csv</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={4}>
                  <DateRangePicker filterByDate={filterByDate} />
                </Grid>

                <Grid item xs={2} className="datapoint-btn-wrap">
                  <Button
                    onClick={exportToExcel}
                    size="small"
                    variant="outlined"
                    className="download-btn"
                    startIcon={<FileDownloadIcon />}
                  >
                    download
                  </Button>
                </Grid>
              </Grid>
            </Grid>
            <Box className="datapoint-map-wrap">
              {apiStatus?.loader ? (
                <DashboardTableSkaleton count={7} />
              ) : (
                <TableContainer className="datapoint-map-container">
                  <Table className="table-output" aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell>Project Name</TableCell>
                        <TableCell>File Name</TableCell>
                        <TableCell>File Extension</TableCell>

                        <TableCell position="end">
                          <Checkbox
                            style={{ paddingLeft: "18px" }}
                            checked={selectAllChecked}
                            onChange={handleSelectAllClick}
                          />
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {dpPoint?.map((list) => {
                        return (
                          <TableRow key={list.id}>
                            <TableCell> {list.project_name}</TableCell>
                            <TableCell align="left">{list.file_name}</TableCell>
                            <TableCell align="left">
                              {list.file_extension}
                            </TableCell>

                            <TableCell position="end">
                              <Checkbox
                                checked={selectedCheckboxes.some(
                                  (checkbox) =>
                                    checkbox.id === list.id &&
                                    checkbox.fileName === list.file_name,
                                )}
                                onChange={(event) =>
                                  handleCheckboxChange(
                                    event,
                                    list.id,
                                    list.file_name,
                                  )
                                }
                              />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </Box>
            {openModal && (
              <DPFiterModal
                modalOpen={openModal}
                handleClose={handleClose}
                handleSubmit={handleSubmit}
                data={dpFormulaList}
                handleFilterEdit={handleFilterEdit}
                handleDelete={handlefilterDelete}
              ></DPFiterModal>
            )}
            {snackBarState && (
              <CustomizedSnackbars
                severity={severity}
                state={snackBarState}
                text={snackbarMessage}
                handleClose={() => setSnackbarState(false)}
              />
            )}
            <Grid className="dataPointDetail1">
              <TablePagination
                component="div"
                rowsPerPageOptions={[100, 200, 300, 500]}
                count={parseInt(pageCount)}
                page={parseInt(page)}
                onPageChange={handlePageChange}
                rowsPerPage={parseInt(rowsPerPage)}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
